<div id="container">
<div class="box1">
<div *ngIf="strLoginUserName!=''" class="titleImage">Welcome {{strLoginUserName}} san!</div>

<!-- 返信フォーム -->
<div class="box3" *ngIf="isEnabledReplyEdit">
  <input type="text" [formControl]="formDocId">
  返信者　<input type="text" [formControl]="formReplyPerson" value="FunnySnowman"><br />
  内容　<textarea cols="70" rows="4" [formControl]="formReplyMessage"></textarea><br />
  <p><button (click)="replyItem()">返信する</button></p>
</div>

<!-- 投稿フォーム -->
<div class="box2" *ngIf="!isEnabledRevise">
  <textarea cols="50" rows="10" placeholder="ご意見・ご感想をください（あとから編集と削除もできます）。" [formControl]="formMessage" required></textarea><br />

  <!-- ログイン済みの場合（ユーザ名を表示） -->
  <div *ngIf="afAuthChild.user | async as user; else showInput">
      <div class="showcontributor">
      Name: {{strLoginUserName}}<br /></div>
    <p><button (click)="addItem()">Submit (投稿する)</button></p>
  </div>
  <!-- ログインしていない場合（インプットBOXを表示） -->
  <ng-template #showInput>
    <input type="hidden" [formControl]="formUid" value="NotLoggedIn">
    Contributor(投稿者)　<input type="text" [formControl]="formContributor" required><br />
    Email(メール)　<input type="email" size="40" placeholder="xxxx@xxxxx" [formControl]="formEmail"><br />
    Not appeared on web（メールアドレスは投稿先の画面には表示されません）<br />
    <div *ngIf="formContributor.value && formMessage.value; else showDisable">
      <p><button (click)="addItem()">Submit(投稿する)</button></p>
    </div>
    <ng-template #showDisable>
      <p><button disabled>Submit(投稿する)</button>　※内容と投稿者を入力してください</p>
    </ng-template>
  </ng-template>

</div>

<!-- 編集フォーム -->
  <div class="box3" *ngIf="isEnabledRevise">
    <input type="hidden" [formControl]="formUpdatedDocId"><br />
    投稿者　<input type="text" [formControl]="formUpdatedContributor"><br />
    内容　<textarea cols="70" rows="6" [formControl]="formUpdatedMessage"></textarea><br />
    メール　<input type="text" size="40" [formControl]="formUpdatedEmail"><br />
    <p><button (click)="updateItem()">更新する</button></p>
  </div>

<!-- ★　メイン：記事一覧を表示する　★ 
<div *ngFor="let item of (items | async) | slice: viewBegin: viewLength">-->
  <div *ngFor="let item of (items | async)">
    <!-- 投稿メッセージを表示する -->
  <div class="kano-tile">
    <div class="showcontributor">
      {{item.contributor}} , {{item.timestamp}}</div>
    <div class="showmessage">{{item.message}}</div>
    <div *ngIf="item.replyMessage" class="showReply">[返信] {{item.replyMessage}} by {{item.replyPerson}}</div>

    <!-- 自分で投稿したメッセージの場合、編集＆削除ボタンを表示する -->
    <!--<div *ngIf="strIsLoggedIn">-->
    <div *ngIf="strKANO"><button  (click)="replyEditItem(item)" >返信</button></div>
    <div *ngIf="item.uid == strUid">
      <button (click)="editItem(item)" [disabled]="isEnabledRevise">編集</button>
      <button (click)="deleteItem(item)" [disabled]="isEnabledDelete">削除</button>
    </div>
    <!--</div>-->
    <!-- <hr width="80%" align="left" sizer="2"> -->
  </div>

</div>
<div class="kano-tile-end"></div>

<!--
<link href="https://fonts.googleapis.com/icon?family=Material+Icons&display=block" rel="stylesheet">
<mat-paginator [length]="100"
              [pageSize]="10"
              [pageSizeOptions]="[5, 10, 25, 100]">
</mat-paginator>
<div class="mat-app-background basic-container">
  <paginator-overview-example>loading</paginator-overview-example>
</div>
-->
<button (click)="showPrevious()">戻る<br />Previous</button>
<button (click)="showNext()">もっと見る<br />See more</button>
<!--
<mat-paginator [length]="viewTotal"
              [pageSize]="viewLength"
              [pageSizeOptions]="[5, 10, 25, 100]">
</mat-paginator>
-->
</div></div>
